import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Select } from "antd";
import DataContext from "../../../context/DataContext";
import {
  CategoryProps,
  DonorProps,
  DonorSourceProps,
  GenderProps,
  SizeProps,
  ProductProps,
} from "../../../types/interfaces";
import Styles from "./DashboardComponents.module.css";
import { BarcodeOutlined } from "@ant-design/icons";
import { ITEM_INITIAL_STATE } from "../../../utils/data";

export const DonatedItemsForm = () => {
  const [form] = Form.useForm();
  const { itemValues, setItemValues, onGenerateBarcode, dataOptions } =
    useContext(DataContext);
  const [buttonGenerateDisabled, setButtonGenerateDisabled] = useState(true);
  const [genderOptions, setGenderOptions] = useState<GenderProps[]>([]);
  const [donorOptions, setDonorOptions] = useState<DonorProps[]>([]);
  const [productOptions, setProductOptions] = useState<ProductProps[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<CategoryProps[]>([]);
  const [sizeOptions, setSizeOptions] = useState<SizeProps[]>([]);
  // const [donorSourceOptions, setDonorSourceOptions] = useState<
  //   DonorSourceProps[]
  // >([]);

  useEffect(() => {
    form.setFieldsValue(ITEM_INITIAL_STATE);
  }, []);

  useEffect(() => {
    if (dataOptions.donatedItems?.length > 0) {
      const genderList = dataOptions.donatedItems.map((gender: GenderProps) => {
        return {
          ...gender,
          value: gender.id.toString(),
        };
      });
      setGenderOptions(genderList);
    }
    if (dataOptions.donorOptions?.length > 0) {
      const donorList = dataOptions.donorOptions.map((donor: DonorProps) => {
        return {
          ...donor,
          value: donor.id.toString(),
        };
      });
      setDonorOptions(donorList);
    }
    setItemValues(ITEM_INITIAL_STATE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      itemValues.gender &&
      itemValues.product &&
      itemValues.category
      // itemValues.donor &&
      // itemValues.donorSource
    )
      setButtonGenerateDisabled(false);
  }, [
    itemValues.gender,
    itemValues.category,
    itemValues.product,
    // itemValues.donor,
    // itemValues.donorSource,
  ]);

  const onChangeGender = (value: string, gender: GenderProps) => {
    console.log(value, gender);
    setItemValues(() => {
      form.setFieldsValue({
        ...ITEM_INITIAL_STATE,
        gender: value,
      });
      return {
        ...ITEM_INITIAL_STATE,
        gender: value,
      };
    });
    const newList =
      gender?.categories?.map((category: CategoryProps) => {
        return {
          ...category,
          value: category.id,
        };
      }) || [];
    setCategoryOptions(newList as any);
    setSizeOptions([]);
  };

  const onChangeCategory = (value: string, category: CategoryProps) => {
    const newList = category.products.map((product: ProductProps) => {
      return {
        ...product,
        value: product.id,
      };
    });
    setProductOptions(newList as any);
    setItemValues((prev) => {
      form.setFieldsValue({
        ...prev,
        category: value,
        size: null,
      });
      return {
        ...prev,
        category: value,
        size: null,
      };
    });
  };

  const onChangeProduct = (value: string, product: ProductProps) => {
    const newList = product.sizes.map((size: SizeProps) => {
      return {
        ...size,
        value: size.id,
      };
    });
    setSizeOptions(newList as any);
    setItemValues((prev) => {
      form.setFieldsValue({
        ...prev,
        product: value,
        size: null,
        donor: null,
      });
      return {
        ...prev,
        product: value,
        size: null,
        donor: null,
      };
    });
  };

  const onChangeDonor = (value: string, donor: DonorProps) => {
    // const newList = donor.donorsource.map((donorSource: DonorSourceProps) => {
    //   return {
    //     ...donorSource,
    //     value: donorSource.id,
    //   };
    // });
    // setDonorSourceOptions(newList as any);
    setItemValues((prev) => {
      form.setFieldsValue({
        ...prev,
        donor: value,
      });
      return {
        ...prev,
        donor: value,
      };
    });
  };

  const filterOption = (
    input: string,
    option?: { label: string; value: string },
  ) =>
    ((option && option.label) || "")
      .toLowerCase()
      .includes(input.toLowerCase());
  return (
    <>
      <Form
        layout="vertical"
        initialValues={itemValues}
        form={form}
        onFinish={() => onGenerateBarcode("donatedItem")}
        className={Styles.form_item}
      >
        <Row gutter={16} justify="center" align="middle">
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              label="1. Gender"
              name="gender"
              rules={[{ required: true, message: "Gender Required" }]}
              className={Styles.form_item}
            >
              <Select
                showSearch
                size="large"
                placeholder="Select a Gender"
                optionFilterProp="children"
                value={itemValues.gender}
                onChange={(value, gender) =>
                  onChangeGender(value, gender as GenderProps)
                }
                filterOption={filterOption}
                options={genderOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              label="2. Category"
              name="category"
              rules={[{ required: true, message: "Category Required" }]}
              className={Styles.form_item}
            >
              <Select
                showSearch
                size="large"
                placeholder="Select Category"
                optionFilterProp="children"
                value={itemValues.category || null}
                onChange={(value, category) =>
                  onChangeCategory(value, category as CategoryProps)
                }
                filterOption={filterOption}
                options={categoryOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} justify="center" align="middle">
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              label={"3. Product"}
              name="type"
              rules={[{ required: true, message: "Product Required" }]}
              className={Styles.form_item}
            >
              <Select
                showSearch
                size="large"
                placeholder="Select a Product"
                optionFilterProp="children"
                value={itemValues.product || null}
                onChange={(value, product) =>
                  onChangeProduct(value, product as ProductProps)
                }
                filterOption={filterOption}
                options={productOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              label="4. Size"
              name="size"
              className={Styles.form_item}
              rules={[
                { required: sizeOptions.length > 0, message: "Size Required" },
              ]}
            >
              <Select
                showSearch
                size="large"
                placeholder="Select a Size"
                optionFilterProp="children"
                value={itemValues.size}
                onChange={(value) => {
                  setItemValues((prev) => {
                    return {
                      ...prev,
                      size: value,
                    };
                  });
                }}
                filterOption={filterOption}
                options={sizeOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify="center" align="middle">
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              label="5. Donor"
              name="donor"
              rules={[{ required: true, message: "Donor Required" }]}
              className={Styles.form_item}
            >
              <Select
                showSearch
                size="large"
                placeholder="Select a Donor"
                optionFilterProp="children"
                value={itemValues?.donor}
                onChange={(value, donor) => {
                  onChangeDonor(value, donor as DonorProps);
                }}
                filterOption={filterOption}
                options={donorOptions}
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} md={12} lg={8}>
            <Form.Item
              label="6. Donor Source"
              name="donorSource"
              rules={[{ required: true, message: "Donor Source Required" }]}
              className={Styles.form_item}
            >
              <Select
                showSearch
                size="large"
                placeholder="Select a Donor Source"
                optionFilterProp="children"
                value={itemValues.donorSource}
                onChange={(value) => {
                  setItemValues((prev) => {
                    return {
                      ...prev,
                      donorSource: value,
                    };
                  });
                }}
                filterOption={filterOption}
                options={donorSourceOptions}
              />
            </Form.Item>
          </Col> */}
        </Row>
        <Row gutter={16} justify="center" align="middle">
          <Button
            type="primary"
            htmlType="submit"
            className={Styles.form_item}
            icon={<BarcodeOutlined />}
            disabled={buttonGenerateDisabled}
          >
            Generate Barcode
          </Button>
        </Row>
      </Form>
    </>
  );
};
